import "@/App.css";
import "@/styles/glass.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { CartProvider } from "@/contexts/CartContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { CartDrawer } from "@/components/bite/CartDrawer";
import { FloatingCart } from "@/components/bite/FloatingCart";
import { FloatingBot } from "@/components/bite/FloatingBot";
import BiteSite from "@/pages/StudyBite";
import FunzSite from "@/pages/FunzSite";
import LandingPage from "@/pages/LandingPage";
import Landing3D from "@/pages/Landing3D";
import LoginPage from "@/pages/LoginPage";
import WebApp from "@/pages/WebApp";
import ChefMode from "@/pages/ChefMode";
import RecruiterMode from "@/pages/RecruiterMode";
import VendorMode from "@/pages/VendorMode";
import RiderMode from "@/pages/RiderMode";
import Onboarding from "@/pages/Onboarding";
import PaymentResult from "@/pages/PaymentResult";
import { ForgotPassword, ResetPassword, VerifyEmail } from "@/pages/AuthPages";
import RulesPage from "@/pages/RulesPage";
import MobileApp from "@/pages/MobileApp";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboard from "@/pages/AdminDashboard";
import { SharePage } from "@/components/SharePage";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <CartProvider>
            <Routes>
              <Route path="/" element={<BiteSite />} />
              <Route path="/funz" element={<FunzSite />} />
              <Route path="/landing" element={<Landing3D />} />
              <Route path="/mobile" element={<MobileApp />} />
              <Route path="/admin" element={<AdminLoginPage />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/qr" element={<SharePage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/onboarding" element={<Onboarding />} />
              <Route path="/app" element={<WebApp />} />
              <Route path="/chef" element={<ChefMode />} />
              <Route path="/vendor" element={<VendorMode />} />
              <Route path="/rider" element={<RiderMode />} />
              <Route path="/recruiter" element={<RecruiterMode />} />
              <Route path="/payment/success" element={<PaymentResult outcome="success" />} />
              <Route path="/payment/cancel" element={<PaymentResult outcome="cancel" />} />
              <Route path="/rules" element={<RulesPage />} />
              <Route path="/forgot" element={<ForgotPassword />} />
              <Route path="/reset" element={<ResetPassword />} />
              <Route path="/verify" element={<VerifyEmail />} />
            </Routes>
            <FloatingCart />
            <FloatingBot />
            <CartDrawer />
          </CartProvider>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
